export default __webpack_public_path__ + "static/media/mysugr_coach_voucher_based_1@3x.bfcf29b2.webp";